import { Injectable, OnDestroy } from '@angular/core';
import { BasePage } from '@app/core/base/base-page';

@Injectable()
export class BaseSetupPage extends BasePage implements OnDestroy {
}
